export const REPORTS_LINK = process.env.REACT_APP_METABASE_LINK;
